import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useHistory } from "react-router-dom";
import routers from "routes/routes";

export const AuthLayout = (props) => {
  const location = useLocation();
  const path = location.pathname;

  const history = useHistory();

  useEffect(() => {
    const found = routers.some((route) =>
      route.childrens?.some(
        (child) => child.path === "/" + path.split("/")[path.split("/").length - 1]
      )
    );

    if (!found && path !== "/dashboard") {
      history.push("/error/page-not-found");
    }
  }, [path, history]);

  return props.children;
};
